import type { PromptAction } from '@src/app/prompt'
import Button from '@ui/Button/Button'

interface ActionProps {
  action: PromptAction
  onClick: (action: PromptAction) => void
}

export default function Action({ action, onClick }: ActionProps) {
  const color =
    action.type === 'primary'
      ? 'default'
      : action.type === 'secondary-outlined'
        ? 'default'
        : 'subtle'
  const variant =
    action.type === 'primary'
      ? 'solid'
      : action.type === 'secondary-outlined'
        ? 'pastel'
        : 'ghost'

  return action.type === 'destructive' ? (
    <Button autoFocus key={action.title} color="red" onClick={() => onClick(action)}>
      {action.title}
    </Button>
  ) : (
    <Button
      autoFocus={action.type === 'primary'}
      variant={variant}
      color={color}
      onClick={() => onClick(action)}
    >
      {action.title}
    </Button>
  )
}
